<template>
    <div class="container-top" :style="style" v-if="isShow">
        <a class="popup-close-button popup-color" @click="onCloseBtn">×</a>
        <div class="container"   >
            <table class="table" style="width: 100%;color:white; font-size: 0.8em;">
                <tr><th scope="col" colspan="4" style="text-align:center;font-size:15px;">{{ title }}主机设置</th></tr>
                <tr><td >主机名称：</td><td >{{ hostName }}</td>
                    <td  >路段名称：</td><td >{{ hostRoad }}</td></tr>
                <tr><td >工作模式：</td>
                    <td ><el-select class="modeSelect" v-model="valueWMode" placeholder="请选择">
                        <el-option v-for="wMode in workModes" :key="wMode.value" :label="wMode.label" :value="wMode.value"></el-option></el-select></td> 
                    <td >闪烁模式：</td>
                    <td ><el-select class="modeSelect" v-model="valueFMode" placeholder="请选择">
                        <el-option v-for="fMode in flashModes" :key="fMode.value" :label="fMode.label" :value="fMode.value"></el-option></el-select></td></tr>
                <tr><td >亮度比例：</td>
                    <td ><el-select class="modeSelect" v-model="valueBMode" placeholder="请选择">
                        <el-option v-for="bMode in brightness" :key="bMode.value" :label="bMode.label" :value="bMode.value"></el-option></el-select></td>
                    <td >尾迹开关：</td>
                    <td ><el-select class="modeSelect" v-model="valueTSMode" placeholder="请选择">
                        <el-option v-for="tsMode in tailSwitchs" :key="tsMode.value" :label="tsMode.label" :value="tsMode.value"></el-option></el-select></td></tr>
                <tr><td >开启时间：</td>
                    <td><el-time-select class="timeSelect"
                                placeholder="起始时间"
                                v-model="startTime"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:05',
                                    end: '23:55'
                                }">
                        </el-time-select></td>
                    <td >结束时间：</td>
                    <td><el-time-select class="timeSelect"
                                placeholder="结束时间"
                                v-model="endTime"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:05',
                                    end: '23:55',
                                    minTime: startTime
                                }">
                        </el-time-select></td></tr>
                <tr><td colspan="4" style="text-align:right;">
                    <el-button class="setBtn" type="success" @click="setLEDBtn">设       置</el-button></td>
                </tr>
            </table>  
                
        </div>
        
        <div class="popup-tip-container">
            <div class="popup-tip  popup-background"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name:'ReviseLEDSet',
    data(){
        return {
            workModes:[{ value:'0', label:'手动模式' },
                       { value:'1', label:'时区模式' },
                       { value:'2', label:'轮廓加强' },
                       { value:'3', label:'主动诱导' },
                       { value:'4', label:'防碰撞'   },
                       { value:'5', label:'自动模式' },
                       { value:'6', label:'偶黄奇红' },
                       { value:'7', label:'偶红奇黄' },
                       { value:'8', label:'全红模式' },
                       { value:'9', label:'测试模式' }],
            flashModes:[{ value:'0', label:'关闭'   },
                        { value:'1', label:'30次/分钟' },
                        { value:'2', label:'60次/分钟'},
                        { value:'3', label:'120次/分钟' },
                        { value:'4', label:'常亮'     },
                        { value:'5', label:'流水灯' }],
            brightness:[{ value:'0', label:'自适应'},
                        { value:'1', label:'10%' },
                        { value:'2', label:'20%' },
                        { value:'3', label:'30%' },
                        { value:'4', label:'40%' },
                        { value:'5', label:'50%' },
                        { value:'6', label:'60%' },
                        { value:'7', label:'70%' },
                        { value:'8', label:'80%' },
                        { value:'9', label:'90%' },
                        { value:'10', label:'100%'}],
            tailSwitchs:[{value:'0',label:'关闭'},
                         {value:'1',label:'开启'}],
            valueWMode:'',
            valueFMode:'',
            valueBMode:'',
            valueTSMode:'',
            ledHosts:'',
            title:'',
            hostRoad:'',
            hostName:'',
            startTime:'',
            endTime:'',
            style:{width:'480px',height:'230px'},
            viewer:'',
            intTimer:'',
            isShow:false ,
        }
    },
    methods:{
        ledHostList(ledHosts){
            console.log('ReviseLEDSet组件 接收到ledHostList = ',ledHosts);
            this.ledHosts = ledHosts ;
        },
        currentLEDSet(gprsAddr){
            clearInterval(this.intTimer);
            this.isShow = true;
            let hostLon = '';
            let hostLat = '';
            this.ledHosts.forEach(element => {
                if(element.gprsAddr == gprsAddr){
                    this.title = gprsAddr ;
                    this.hostRoad = element.road ;
                    this.hostName = element.name ;
                    hostLon = element.lon;
                    hostLat = element.lat;
                }
            });

            // 启动定时器，当鼠标拖动地球时，该设置界面跟着雾灯一起移动
            this.intTimer = setInterval(()=>{
                let coord = bd09_to_wgs84(hostLon ,hostLat);
                let cartesian3 = Cesium.Cartesian3.fromDegrees(coord.longitude, coord.latitude,0);
                let cartesian2 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene,cartesian3);
                // console.log('cartesian2 and cartesian3 = ',this.viewer.scene,cartesian2, cartesian3);
                this.style.left = cartesian2.x -325 +'px'; //325
                this.style.top = cartesian2.y - 220   + 'px';//- 220
            },100);
                       


            let url = "http://47.111.99.118:8089/system/getParamSet?gprsAddr=" + gprsAddr;
            console.log('ReviseLEDSet 组件 url = ',url);
            axios.get(url).then(
                response=>{
                    console.log('ReviseLEDSet 组件 请求成功 = ',response.data)
                    let wIndex = '';
                    if(response.data.mode == '0'){
                        wIndex = 0;
                    }else if(response.data.mode == '1'){
                        wIndex = 1;
                    }else if(response.data.mode == '2'){
                        wIndex = 2;
                    }else if(response.data.mode == '3'){
                        wIndex = 3;
                    }else if(response.data.mode == '4'){
                        wIndex = 4;
                    }else if(response.data.mode == '5'){
                        wIndex = 5;
                    }else if(response.data.mode == '6'){
                        wIndex = 6;
                    }else if(response.data.mode == '7'){
                        wIndex = 7;
                    }else if(response.data.mode == '8'){
                        wIndex = 8;
                    }else if(response.data.mode == '9'){
                        wIndex = 9;
                    }else{
                        wIndex = 0;
                    }
                    this.valueWMode = this.workModes[wIndex];

                    let flIndex = 0;
                    if(response.data.flashMode == "关闭"){
                        flIndex = 0 ;
                    }else if(response.data.flashMode == "30次/分钟"){
                        flIndex = 1 ;
                    }else if(response.data.flashMode == "60次/分钟"){
                        flIndex = 2 ;
                    }else if(response.data.flashMode == "120次/分钟"){
                        flIndex = 3 ;
                    }else if(response.data.flashMode == "常亮"){
                        flIndex = 4 ;
                    }else if(response.data.flashMode == "流水灯"){
                        flIndex = 5 ;
                    }else{
                        flIndex = 0 ;
                    }
                    this.valueFMode = this.flashModes[flIndex];

                    let btIndex = 0;
                    if(response.data.brightness == "自适应"){
                        btIndex = 0
                    }else if(response.data.brightness == "10"){
                        btIndex = 1
                    }else if(response.data.brightness == "20"){
                        btIndex = 2
                    }else if(response.data.brightness == "30"){
                        btIndex = 3
                    }else if(response.data.brightness == "40"){
                        btIndex = 4
                    }else if(response.data.brightness == "50"){
                        btIndex = 5
                    }else if(response.data.brightness == "60"){
                        btIndex = 6
                    }else if(response.data.brightness == "70"){
                        btIndex = 7
                    }else if(response.data.brightness == "80"){
                        btIndex = 8
                    }else if(response.data.brightness == "90"){
                        btIndex = 9
                    }else if(response.data.brightness == "100"){
                        btIndex = 10
                    }else{
                        btIndex = 0
                    }
                    this.valueBMode = this.brightness[btIndex];

                    let tsIndex = 0;
                    if(!response.data.tailSwitch){
                        tsIndex = 0
                    }else{
                        tsIndex = 1
                    }
                    this.valueTSMode = this.tailSwitchs[tsIndex];

                    this.startTime = response.data.startTime ;
                    this.endTime = response.data.endTime ;
                },
                error=>{
                    console.log('ReviseLEDSet 组件 请求失败！',error.message);
                }
            )
            this.isShow = true ;
            // "http://47.111.99.118:8089/system/getParamSet?gprsAddr=" + hostId;    
        },
        // 设置功能还有待验证，目前数据库的格式未能找到，查询了数据库，未能找到单个雾灯的数据库
        setLEDBtn(){
            console.log('ReviseLEDSet 组件 数据集合：',this.valueWMode.value,
                                                    this.valueFMode.label,
                                                    this.valueBMode.value += '0',
                                                    this.valueTSMode.value,
                                                    this.title,
                                                    this.hostRoad,
                                                    this.hostName,
                                                    this.startTime,
                                                    this.endTime)
            var mode = "mode='" + this.valueWMode.value + "',";

            var tailSwitch ;
            if (this.valueTSMode.value == 1)
                tailSwitch = "tailSwitch=1,";
            else{
                tailSwitch = "tailSwitch=0,";
            }
            var flashMode = "flashMode='" + this.valueFMode.label + "',";
            var brightness = "brightness='" + this.valueBMode.value + "',";
            var startTime = "startTime='" + this.startTime + "',";
            var endTime = "endTime='" + this.endTime + "'";
            var sql = "UPDATE HostTable SET  " + mode + tailSwitch + flashMode + brightness + startTime + endTime;

            this.onSendHostListToSql(sql,this.title);
            var url = "http://47.111.99.118:8089/system/paramSet?gprsAddr=" + this.title;
            axios.get(url).then(
                response=>{
                    alert('ReviseLEDSet 组件 数据设置成功',response.data);
                    clearInterval(this.intTimer);
                    this.isShow = false;
                },
                error=>{
                    console.log('ReviseLEDSet 组件 数据设置失败',error.message);
                }
            )

        },
        onSendHostListToSql(sql,gprsAddress){
            var gprsAddr = gprsAddress ;
            sql = sql + " WHERE hostID='" + gprsAddr + "';";

            var url = "http://47.111.99.118:8089/system/sqlQuery" ;
            axios.post(url,sql).then(
                response=>{
                    console.log('ReviseLEDSet 组件 保存数据库成功',response.data);
                },
                error=>{
                    console.log('ReviseLEDSet 组件 数据库保存  失败',error.message);
                }
            )
        },
        getViewer(viewer){
            this.viewer = viewer;
        },
        onCloseBtn(){
            clearInterval(this.intTimer);
            this.isShow = false;
        }
    },
    mounted(){
        this.$bus.on('LEDHostListDatas',this.ledHostList);//更新雾灯列表
        // 获取从 DisplayLEDHostOnMap 组件，点击当前雾灯事件
        this.$bus.on('currentLEDSet',this.currentLEDSet);  
        this.$bus.on('getViewer',this.getViewer);
    },
    unmounted(){
        this.$bus.off('LEDHostListDatas');
        this.$bus.off('currentLEDSet');
        this.$bus.off('getViewer');
        clearInterval(this.intTimer);
    }

}
</script>

<style scoped>
.container-top{
    position: absolute;
}
td:nth-child(1),:nth-child(3){
    width: 90px;
    text-align: center;
}
td:nth-child(2),:nth-child(4){
    width: 90px;
    text-align: left;
    /* padding-left: 5px; */
}
.setBtn{
    float: right;
    width: 80px;
    margin-right: 3%;
    margin-top: 1%;
}

.modeSelect{
    width: 140px;
    margin-right: 5px;
}
.timeSelect{
    width: 140px;
    margin-right: 5px;
}
.container{
    position: absolute;
    width: 480px;
    height: 215px;
    background-color: rgba(0, 0, 0, .8);
    border-radius: 5px;
}
.table{
    padding-top: 5px;
    padding-right: 5px;
    /* text-align:left; */
    /* padding-left: 5px;
    padding-bottom: 5px; */
}
.popup-tip-container {
    margin: 215px 230px;
    width: 40px;
    height: 13px;
    position: absolute;
    overflow: hidden; 
}
.popup-tip {
    box-shadow: 0 3px 14px rgba(0, 0, 0, .6);
    width: 17px;
    height: 17px;
    padding: 1px;
    margin: -10px auto 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
.popup-background {
    background: rgba(0, 0, 0, .6);
    border-radius: 6px;
}


.popup-close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px 4px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 99;
  }

.popup-close-button:hover {
    cursor: pointer;
    color: red;
}
.popup-color {
    color: white;
  }
</style>